import { GridcoTitle } from "../components";
import { GridcoDashboardItem, TabSwitcher } from "../Gridco_Das";
import { ReactComponent as BankingAalytics } from "../../../icons/dashboard/bankingAnalytics.svg";
import Hamburger from "../../../components/Hamburger";
import { ReactComponent as GNAiIcon } from "../../../icons/gnai_logo.svg";

export function Automation() {
  return (
    <div className="w-full">
      <div className="header grid grid-cols-3 gap-5 items-center justify-between">
        {" "}
        <div className="col-span-1 flex items-center gap-5">
          <GNAiIcon width={80} />
          <Hamburger />
          <div className="">
            <TabSwitcher />
          </div>
        </div>
        <div className="flex-1 flex justify-center">
          <GridcoTitle />
        </div>
      </div>
      <div className="dashboard-item-container">
        <div className="flex flex-col justify-between h-full">
          <div className="flex flex-row flex-wrap gap-5 justify-center">
            <GridcoDashboardItem
              Icon={BankingAalytics}
              title="Bid Automation"
              to="bid-automation"
            />
            <GridcoDashboardItem
              Icon={BankingAalytics}
              title="DAM Performance Analysis"
              to="dam-performance"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
